import { useEffect } from 'react';
import { useProject } from '@/hooks/useProject';

export const ProjectContextInitializer = () => {
  const { currentProject, projectId } = useProject();

  // Este componente solo inicializa el contexto, no renderiza nada
  useEffect(() => {
    console.log(`🔍 ProjectContextInitializer - Proyecto inicializado: ${currentProject}, projectId: ${projectId}`);
  }, [currentProject, projectId]);

  return null; // No renderiza nada
};
